import 'slick';
import $ from 'jquery';
import {PageController} from './PageController';
import {isMobile} from '../utils/mobileDetect';
import {StickyElement} from '../components/StickyElement';
import {ColorizedImage, ColorizedBackgroundImage} from '../components/ColorizedImage';

/**
 * @name ArticlePageController
 * @class Article page specific functionality
 */
class ArticlePageController extends PageController {

    constructor() {
        super();
        
        this.init();
        //StickyElement.start('address.ar-summary-card', '.ar-article-sticky-parent');
    }

    /**
     * Controller initialiser
     * @private
     */
    init() {
        $(document.body).addClass('ar-article-template')
        ColorizedImage.applyToElements('.colorized-image');
        ColorizedBackgroundImage.applyToElements('.colorized-background-image');
    }
}

export var controller = new ArticlePageController();